 $(document).ready(function(){

        $('.reviewSlider').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            infinite: true,
            prevArrow: `
                <button class="slick-prev slick-arrow">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M21 12L3 12" stroke="#672666" stroke-linecap="round"></path>
                        <path d="M9 6L3 12L9 18" stroke="#672666" stroke-linecap="round"></path>
                    </svg>
                </button>`,

                nextArrow: `
                <button class="slick-next slick-arrow">
                    <svg width="50" height="50" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                        <path d="M3 12H21M21 12L15 18M21 12L15 6" stroke="#672666" stroke-linecap="round"></path>
                    </svg>
                </button>`,
            speed: 600,

            responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 3 }
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 }
            }
            ]
        });

        });





         $(document).ready(function(){

            $('.galleryMainSlider').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                asNavFor: '.galleryThumbSlider',
                arrows: true,

                prevArrow: `
                <button class="slick-prev slick-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                    </svg>
                </button>`,

                nextArrow: `
                <button class="slick-next slick-arrow">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>`
            });


            $('.galleryThumbSlider').slick({
                slidesToShow: 5,
                slidesToScroll: 1,
                asNavFor: '.galleryMainSlider',
                focusOnSelect: true,
                centerMode: true,
                arrows: false, // thumbnail e arrow lagbe na usually
                responsive: [
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 3,
                    centerMode: false,
                    }
                }
                ]
            });

            });












            document.addEventListener("DOMContentLoaded", function () {

            const targetUrl = "https://sleepgram.com/products/slumberaid";

            document.querySelectorAll(".go-slumberaid").forEach(el => {
                el.addEventListener("click", function(e) {
                e.preventDefault(); // anchor hole default stop
                window.location.href = targetUrl;
                });
            });

            });